// const assets = require('./assets.config'); // generated file, do not include
const medias = require('./medias.config');
const theme = require('./theme.config');
const global = require('./global.config');
// const local = require('./local.config');

module.exports = {
  // assets,
  medias,
  theme,
  ...global,
  //   ...local,
};
